import React, { useState } from 'react';
import { Container, Grid, Typography, Box, Card, Dialog, DialogTitle, DialogContent, DialogActions, Button, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PieChartIcon from '@mui/icons-material/PieChart';
import PeopleIcon from '@mui/icons-material/People';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import LocalMall from '@mui/icons-material/LocalMall';
import Engineering from '@mui/icons-material/Engineering';
import Fastfood from '@mui/icons-material/Fastfood';


// Estilo personalizado para las tarjetas de información
const InfoCard = styled(Card)(({ theme }) => ({
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  padding: '10px',
  backgroundColor: '#F0F4F8',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  marginBottom: '10px',
  cursor: 'pointer',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

const MoreInfoButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  padding: '4px 8px',
  fontSize: '0.875rem',
  color: '#1F3D58',
  backgroundColor: '#E0E7EF',
  '&:hover': {
    backgroundColor: '#D0D8DF',
  },
}));

const Top3Industries = ({ handleOpenDialog }) => {
  const topIndustries = [
    { category: "Pallets", industry: "Alimentos", value: "1,471,680" },
    { category: "Tons", industry: "Construcción", value: "3,600,000" },
    { category: "Millones", industry: "Retail", value: "34,646,182" },
  ]};

const DialogContentWrapper = styled(Box)({
  padding: '20px',
  fontSize: '1rem',
  color: '#333',
  lineHeight: '1.6',
});

const DialogSectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.2rem',
  marginBottom: theme.spacing(1),
  color: '#1F3D58',
}));

const InfoBoxes = () => {
  const [open, setOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState({ title: '', content: '' });

  const handleOpenDialog = (title, content) => {
    setDialogContent({ title, content });
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <Container sx={{ marginBottom: '5px', marginTop: '20px', }}>
      <Grid container spacing={2}>

             {/* GRID NUEVA*/}
  <Grid item xs={12} md={12}>
  <InfoCard sx={{ marginBottom: '1px'}} >
    <Typography variant="h5" textAlign="center" sx={{fontWeight: 'bold', color: '#1F3D58', width: '100%' }}>
    Top 3 Industrias - Carga Anual
    </Typography>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      textAlign="center"
      width='100%'
      px={3}
    >
      <Box textAlign="center">
        <LocalMall sx={{ fontSize: 50, color: '#1F3D58', marginBottom: 2, marginLeft: '100px' }} />
        <Typography sx={{ marginLeft: '100px' }}variant="h6">Alimentos</Typography>
        <Typography sx={{ marginLeft: '100px',fontWeight: 'bold' }}variant="body1"> 0.9 millones de pallets</Typography>
      </Box>

      <Divider
        orientation="vertical"
        flexItem
        sx={{ bgcolor: '#1F3D58', width: '2px', height: '100px' }}
      />

      <Box textAlign="center">
        <LocalMall sx={{ fontSize: 50, color: '#1F3D58', marginBottom: 2 }} />
        <Typography variant="h6">Construcción</Typography>
        <Typography sx={{ fontWeight: 'bold' }}variant="body1"> 2.3 millones toneladas</Typography>
      </Box>

      <Divider
        orientation="vertical"
        flexItem
        sx={{ bgcolor: '#1F3D58', width: '2px', height: '100px' }}
      />

      <Box textAlign="center">
        <LocalMall sx={{ fontSize: 50, color: '#1F3D58', marginBottom: 2, marginRight: '100px' }} />
        <Typography sx={{ marginRight: '100px' }}variant="h6">Retail</Typography>
        <Typography sx={{ marginRight: '100px',fontWeight: 'bold' }}variant="body1"> 29.5 millones de unidades</Typography>
      </Box>
    </Box>
  </InfoCard>
</Grid>

        {/* Primera tarjeta: Sector Alimentación */}
        <Grid item xs={12} md={4}>
          <InfoCard sx={{ marginTop: '20px'}}>
            <Box display="flex" alignItems="center">
              <InfoIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">28% Sector retail</Typography>
                <Typography variant="body2">La industria más representada en el estudio.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Sector Alimentación', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                  La industria de retail representa un 28% de los datos recolectados en este estudio, siendo el sector con mayor representación.
                </Typography>
                <Divider sx={{ marginY: 2 }} />
                <DialogSectionTitle>Factores Clave</DialogSectionTitle>
                <ul>
                  <li>Alta demanda de productos alimenticios.</li>
                  <li>Gran diversidad de proveedores y productos.</li>
                  <li>Estabilidad en el sector frente a otras industrias.</li>
                </ul>
                <Divider sx={{ marginY: 2 }} />
                <DialogSectionTitle>Impacto</DialogSectionTitle>
                <Typography paragraph>
                  Este sector es fundamental para la economía, generando empleo y asegurando el abastecimiento de productos de primera necesidad.
                </Typography>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

        {/* Segunda tarjeta: Fill Rate */}
        <Grid item xs={12} md={4}>
          <InfoCard sx={{ marginTop: '20px'}}>
            <Box display="flex" alignItems="center">
              <AssessmentIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">98% Fill rate</Typography>
                <Typography variant="body2">Salud/ Farmacéuticas y Logistica sector con mejor desempeño.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Fill Rate', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                  El sector logístico alcanzó un Fill Rate del 98%, lo que refleja una alta eficiencia en la gestión de inventarios y en la satisfacción de la demanda.
                </Typography>
                <Divider sx={{ marginY: 2 }} />
                <DialogSectionTitle>Indicadores Relacionados</DialogSectionTitle>
                <ul>
                  <li>Tiempo de respuesta rápido.</li>
                  <li>Baja tasa de devoluciones.</li>
                  <li>Optimización en la cadena de suministro.</li>
                </ul>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

        {/* Tercera tarjeta: Facturación */}
        <Grid item xs={12} md={4}>
          <InfoCard sx={{ marginTop: '20px'}}>
            <Box display="flex" alignItems="center">
              <PieChartIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">39% Facturacion {">"} 250 MDP"</Typography>
                <Typography variant="body2">Las empresas con mayor facturación.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Facturación > 250 MDP', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                  El 39% de las empresas participantes en el estudio tienen una facturación mayor a 250 millones de pesos, lo cual representa su influencia en la economía.
                </Typography>
                <Divider sx={{ marginY: 2 }} />
                <DialogSectionTitle>Aspectos destacados</DialogSectionTitle>
                <ul>
                  <li>Mayores ingresos generan mayor capacidad de inversión.</li>
                  <li>Estabilidad financiera frente a fluctuaciones del mercado.</li>
                </ul>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

        {/* Nueva tarjeta: Retención de Personal */}
        <Grid item xs={12} md={4}>
          <InfoCard >
            <Box display="flex" alignItems="center">
              <PeopleIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">Rotación del Personal</Typography>
                <Typography variant="body2">Sector manufactura con una rotación controlada del 28%.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Rotación de Personal', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                La industria manufacturera enfrenta una alta rotación de personal, alcanzando un 28% anual.
                </Typography>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <InfoCard >
            <Box display="flex" alignItems="center">
              <PeopleIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">Eficiencia Operativa</Typography>
                <Typography variant="body2">Las empresas del sector Automotriz estan asegurando que el 90% de las órdenes.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Retención de Personal', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                Las empresas del sector automotriz mantienen un alto estándar en la precisión de las entregas, asegurando que el 90% de las órdenes llegan completas y sin errores al cliente final. Este indicador refleja una cadena de suministro optimizada, donde se minimizan los errores en el proceso de picking, empaque y despacho.
                </Typography>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

        {/* Nueva tarjeta: Eficiencia en Entregas a Tiempo */}
        <Grid item xs={12} md={4}>
          <InfoCard>
            <Box display="flex" alignItems="center">
              <LocalShippingIcon sx={{ fontSize: 40, color: '#1F3D58', marginRight: 2 }} />
              <Box>
                <Typography variant="h6">Eficiencia en entregas</Typography>
                <Typography variant="body2">98% En entregas a tiempo en el sector de Salud / farmacéutica.</Typography>
              </Box>
            </Box>
            <MoreInfoButton onClick={() => handleOpenDialog('Eficiencia en Entregas a Tiempo', (
              <DialogContentWrapper>
                <DialogSectionTitle>Descripción</DialogSectionTitle>
                <Typography paragraph>
                  El sector de salud/farmacéutica reporta una eficiencia del 98% en entregas a tiempo, clave para la satisfacción del cliente.
                </Typography>
              </DialogContentWrapper>
            ))}>
              Más información
            </MoreInfoButton>
          </InfoCard>
        </Grid>

  
      </Grid>
      

      {/* Dialog para mostrar más información */}
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{dialogContent.title}</DialogTitle>
        <DialogContent>{dialogContent.content}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default InfoBoxes;
